import styled from 'styled-components';

const ErrorBanner = styled.div`
	padding: 10px;
	font-family: 'GT Walsheim Pro';
	font-size: 14px;
	line-height: 16px;
	color: white;
	background: #ff3737;
	border-radius: 6px;
	user-select: none;
	pointer-events: none;
`;

export { ErrorBanner };
